/**
 * Provides custom variants
 */
import { variant } from 'styled-system';

import { transforms } from 'theme/variants/transforms';

export const VARIANTS = {
  button: {
    accentColor: variant({
      prop: 'accentColor',
      key: 'buttons',
    }),
    size: variant({
      prop: 'size',
      key: 'buttonSizes',
    }),
  },
  typography: {
    fontWeight: variant({
      prop: 'fontWeight',
      key: 'fontWeights',
    }),
  },
  transforms,
};
